// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"69f076c4","787":"5679b30d"}[chunkId] + ".chunk.js";
};